import { useState, useEffect, useCallback, useRef } from 'react';
import type { RefObject } from 'react';

interface UseTableHeightResult {
  tableHeight: string;
  tableContainerRef: RefObject<HTMLDivElement | null>;
}

export const useTableHeight = (
  dependencies: unknown[] = []
): UseTableHeightResult => {
  const [tableHeight, setTableHeight] = useState<string>('auto');
  const tableContainerRef = useRef<HTMLDivElement>(null);

  const calculateTableHeight = useCallback((): void => {
    if (!tableContainerRef.current) return;

    const windowHeight = window.innerHeight;
    const globalFooterHeight =
      document.querySelector('.global-footer')?.clientHeight || 0;
    const tableContainerRect =
      tableContainerRef.current.getBoundingClientRect();
    const availableHeight =
      windowHeight - tableContainerRect.top - globalFooterHeight - 24;

    setTableHeight(`${Math.max(300, availableHeight)}px`);
  }, []);

  useEffect(() => {
    calculateTableHeight();
    window.addEventListener('resize', calculateTableHeight);

    return () => window.removeEventListener('resize', calculateTableHeight);
  }, [calculateTableHeight]);

  useEffect(() => {
    calculateTableHeight();
  }, [...dependencies, calculateTableHeight]);

  return { tableHeight, tableContainerRef };
};

export default useTableHeight;
